// extracted by mini-css-extract-plugin
export var childrenContainer = "_3d-0";